import React from 'react'
import RemoveOrDeleteRow from '@front/squirtle/components/FormTable/Actions/RemoveOrDeleteRow'

const ButtonComponent = ({ rowId, onDelete, ...props }) =>
  <RemoveOrDeleteRow rowId={rowId} onDelete={onDelete} />

export default React.memo(ButtonComponent)
